/**
 * menu ustawień aplikacji po zalogowaniu się
 */

export default []
